<template>
  <div
    class="ai-generated-overlay">
    <svg-sparkle
      class="sparkle-icon"
      width="20"
      height="20"/>
    <span class="ai-generated-text">AI Model</span>
  </div>
</template>

<script setup>
import SvgSparkle from '@/components/global/svg/SvgSparkle.vue'

</script>

<style lang="scss" scoped>
.ai-generated-overlay {
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 0px 6px;
  border-radius: 4px;
  z-index: 10;
}

.sparkle-icon {
  flex-shrink: 0;
  color: black;
}

.ai-generated-text {
  font-size: 12px;
  font-weight: 500;
  color: black;
  white-space: nowrap;
}
</style>


